<template>
    <div id="wqsd"  :style="{width:clientW+'px',height:clientH+'px'}" style="margin:0 auto">
        <div class="wqsdframe">
            <div class="wqsdframe-title">
                <img :src="imgPath+'wqsdtitle.png'" alt="">
            </div>
            <div class="wqsdframe-content">
                <video preload="auto" controls="controls" playsinline="" webkit-playsinline="webkit-playsinline"
                x-webkit-airplay="allow" x5-video-player-type="h5" x5-video-player-fullscreen="true" :src="videoUrl"
                style="width: 100%; object-fit: cover; background: rgb(0, 0, 0);"></video>
            </div>
        </div>
        <div class="back" @click="black">
            <img :src="imgPath+'back.png'" alt="">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            clientW:document.body.clientWidth,
            clientH:document.body.clientHeight,
            imgPath:imgPath,
            videoUrl:'https://video.shundecity.com/135cd661aebd4261a447073fb35e608a/2ba889e126ff4af1a373f610e1c7208a-66b776d29f51a6bb0a83444955c4f75b-hd.mp4'
        }
    },
    created(){
        this.getViewScale();
    },
    methods: {
         getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        },
        black(){
            this.$router.back(-1);//放回上一页
        },
    },
}
</script>
<style lang="less" scoped>
 @base:46.875rem;
#wqsd{
    background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/otherbg.png);
    background-size: 100% 100%;
    position: relative;
    .wqsdframe{
        width: 90%;
        padding: 90/@base 20/@base 20/@base;
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        box-shadow:  0 0 20px 10px rgba(255, 255, 255, 0.3);
        .wqsdframe-title{
            width:334/@base;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,-30%);
        }
        .wqsdframe-content{
            width: 100%;
            height: 100%;
        }
    }
    .back{
        position: absolute;
        width: 113/@base;
        left: 50%;
        top: 80%;
        transform: translateX(-50%);
    }
}   
</style>


// WEBPACK FOOTER //
// src/pages/Wqsd.vue